import React, { useState } from 'react';
import { Box, IconButton, Typography } from '@mui/joy';
import { motion, AnimatePresence } from 'framer-motion';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const ToolCallMessage = ({ message, nested = false }) => {
  const [expanded, setExpanded] = useState(false);

  const content = (
    <>
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 1,
          px: 1.5,
          py: 0.75,
          borderRadius: 'md',
          bgcolor: (theme) => theme.palette.mode === 'dark' ? 'neutral.800' : 'neutral.50',
          border: '1px solid',
          borderColor: (theme) => theme.palette.mode === 'dark' ? 'neutral.700' : 'neutral.200',
          cursor: message.tool_args ? 'pointer' : 'default',
          transition: 'all 0.15s ease',
          '&:hover': message.tool_args
            ? {
              bgcolor: (theme) => theme.palette.mode === 'dark' ? 'neutral.700' : 'neutral.100',
              borderColor: (theme) => theme.palette.mode === 'dark' ? 'neutral.600' : 'neutral.300',
            }
            : {},
        }}
        onClick={() => message.tool_args && setExpanded(!expanded)}
      >
        <Box
          sx={{
            width: 24,
            height: 24,
            borderRadius: 'sm',
            bgcolor: (theme) => theme.palette.mode === 'dark' ? 'neutral.700' : 'neutral.200',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <BuildOutlinedIcon sx={{ fontSize: 14, color: (theme) => theme.palette.mode === 'dark' ? 'neutral.300' : 'neutral.600' }} />
        </Box>

        <Typography level="body-sm" sx={{ fontWeight: 500, color: 'text.secondary' }}>
          Using <strong style={{ color: 'var(--joy-palette-text-primary)' }}>{message.tool_name}</strong>
        </Typography>

        {message.tool_args && (
          <IconButton
            size="sm"
            variant="plain"
            color="neutral"
            sx={{
              '--IconButton-size': '20px',
              ml: 0.5,
              transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s ease',
            }}
          >
            <KeyboardArrowDownIcon sx={{ fontSize: 16 }} />
          </IconButton>
        )}
      </Box>

      <AnimatePresence>
        {expanded && message.tool_args && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.2 }}
          >
            <Box
              component="pre"
              sx={{
                mt: 1,
                p: 1.5,
                bgcolor: 'neutral.900',
                color: 'neutral.100',
                borderRadius: 'md',
                fontSize: '0.75rem',
                fontFamily: 'monospace',
                overflow: 'auto',
                maxHeight: 200,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
              }}
            >
              {JSON.stringify(message.tool_args, null, 2)}
            </Box>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );

  if (nested) return content;

  return <Box sx={{ mb: 2, pl: 7 }}>{content}</Box>;
};

export default ToolCallMessage;
